module.exports = __webpack_public_path__ + "static/media/hands_07.5068d193.svg";